import {produce} from 'immer';
import { noop } from '../fun';
export const immer = produce;
export const immerv = (x: any) => immer((k) => noop(x(k)));
